import GiganautVueForm from '@/components/Shared/GiganautVueForm';

export default class GiganautVueDialog extends GiganautVueForm {
  
  public dialog = false;
}
